import { render, staticRenderFns } from "./listV2.vue?vue&type=template&id=9aa68924&scoped=true"
import script from "./listV2.vue?vue&type=script&lang=js"
export * from "./listV2.vue?vue&type=script&lang=js"
import style0 from "./listV2.vue?vue&type=style&index=0&id=9aa68924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa68924",
  null
  
)

export default component.exports